<template>
    <section class="content__body">
        <table class="table__">
            <thead>
            <tr>
                <th>
                    <span
                        class="btn-order"
                        @click="changeOrder('title_asc')">
                      {{ $t('words.name') }}
                      <span class="icon-triangle-wrap">
                        <i
                            :class="{'active':order === 'title_asc'}"
                            class="icon icon-triangle-up"/>
                        <i
                            :class="{'active':order === 'title_desc'}"
                            class="icon icon-triangle-down"/>
                      </span>
                    </span>
                </th>
                <th class="cell--number">
                    {{ $t('words.size') }}(GiB)
                </th>
                <th class="cell--number">{{ $t('words.play_time') }}</th>
                <th class="cell--number">
                    <span
                        class="btn-order"
                        @click="changeOrder('created_at_asc')">
                       {{ $t('words.upload_time') }}
                      <span class="icon-triangle-wrap">
                        <i
                            :class="{'active':order === 'created_at_asc'}"
                            class="icon icon-triangle-up"/>
                        <i
                            :class="{'active':order === 'created_at_desc'}"
                            class="icon icon-triangle-down"/>
                      </span>
                    </span>
                </th>
                <th class="cell--number">{{ $t('words.program_ready_time') }}</th>
                <th class="cell--action"/>
            </tr>
            </thead>
            <!-- 로딩 끝나고 데이터가 하나라도 있을때 -->
            <tbody v-if="mediaContents.load && (mediaContents.meta.total > 0)">
            <!-- mediaContents Data Render -->
            <MediaContentsTableRow
                v-for="mediaContent in mediaContents.data"
                :key="`${mediaContent.id}`"
                :haveSubmitRight="haveSubmitRight"
                :mediaContent="mediaContent"
                @doRemoveMediaContent="doRemoveMediaContent"
            />
            </tbody>
            <!-- 로딩 끝나고 데이터가 하나도 없을때 -->
            <tbody v-else-if="mediaContents.load">
            <tr>
                <td
                    class="cell--message"
                    colspan="8">
                    <InformationSvg/>
                    {{ $t('paragraphs.recording_list_empty') }}
                </td>
            </tr>
            </tbody>
            <!-- 로딩 중일때 -->
            <tbody v-else>
            <tr>
                <td
                    class="cell--message"
                    colspan="8">
                    <div class="loader"/>
                    {{ $t('paragraphs.list_loading') }}
                </td>
            </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
import GlobalConfigMixin from '@/components/mixin/GlobalConfigMixin';
import MediaContentsTableRow from '@/components/cms/common/Content/ContentBodyTable/MediaContentsTableRow';
import InformationSvg from '@/components/svg/InformationSvg';
import _ from 'lodash';

export default {
    name: 'MediaContentsBody',
    components: {
        MediaContentsTableRow,
        InformationSvg,
    },
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        order: {
            type: String,
            default: '',
        },
        mediaContents: {
            type: Object,
            default: () => ({
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            }),
        },
    },
    computed: {
        haveSubmitRight() {
            return this.haveOwnerRight;
        },
    },
    methods: {
        changeOrder(order) {
            const newOrder = order.match(/^(.*)_(asc|desc)$/);
            const curOrder = this.order.match(/(.*)_(asc|desc)$/);
            if (newOrder.length < 3) {
                return;
            }
            if (curOrder !== null && curOrder.length > 2 && newOrder[1] === curOrder[1]) {
                switch (curOrder[2]) {
                case 'asc':
                    newOrder[2] = 'desc';
                    break;
                case 'desc':
                    newOrder[2] = '';
                    break;
                default:
                    newOrder[2] = 'asc';
                    break;
                }
            }
            this.setOrder(!_.isEmpty(newOrder[2]) ? `${newOrder[1]}_${newOrder[2]}` : '');
            this.doSearch();
        },
        setOrder(value) {
            this.$emit('setOrder', value);
        },
        doSearch() {
            this.$emit('doSearch');
        },
        doRemoveMediaContent(mediaContent) {
            this.$emit('doRemoveMediaContent', mediaContent);
        },
    },
};
</script>
